export default "__VITE_ASSET__hR6PkuSG__"